export default "__VITE_ASSET__iU7g27AO__"